
<div *ngIf="book.novita==='0'">
  <span style="color:green"  >
   Libro distribuito
  </span>
</div>

<div *ngIf="book.novita==='1'" > 
  <span style="color:red" *ngIf="scaduto">
    Novità scaduta
  </span>
  <div>
    <span style="color:green" *ngIf="book.flag_giacenza === '1'">  Prodotto in magazzino   </span>
   <span *ngIf="!scaduto && book.flag_giacenza === '0'">Giorni all'ultima data di consegna magazzino :</span>
 <span
          *ngIf="book.flag_giacenza === '0' && !scaduto" 
            [style]="
              book.giorni_consegna <= 21
                ? 'color:red'
                : 'color:blue'
            "
            >{{ book.giorni_consegna }}</span
          >
          
</div>

</div> 